import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'

const GeneralSection = () => {
  return (
    <Grid direction="column" gap={0.5}>
      <Col>
        <FormItem label="Nome*" field="bucketName" />
      </Col>
    </Grid>
  )
}

export default GeneralSection
